import { Form, Formik } from 'formik';
import InputText from '../../../components/input-text/inputText';
import ModalComponent from '../../../components/modal/modal';
import ModalBody from '../../../components/modal/modalBodyComponent';
import ModalFooterComponent from '../../../components/modal/modalFooterComponent';
import CustomToggle from '../../../components/toggle';
import { usePostSystemAlertConfiguration } from '../../../hooks';
import { type ModalStatusType } from '../../../types/common';
import { SYSTEM_ALERT_CONFIGURATION_VALIDATION } from '../../../utils/validations/validations';
import _ from 'lodash';

interface SystemAlertConfigurationModalType {
  isModalOpen: boolean;
  closeModal: () => void;
  setModalStatus: (value: ModalStatusType) => void;
  initialData: {
    data: {
      name: string;
      email: string;
      isActive: boolean;
    };
    id: string;
    modalStatus: ModalStatusType;
  };
  loading: boolean;
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>;
  id?: string;
}

const SystemAlertConfigurationModal = ({
  isModalOpen,
  closeModal,
  initialData,
  setModalStatus,
  loading,
  handleRequest,
  id,
}: SystemAlertConfigurationModalType): JSX.Element => {
  const { mutate, isLoading } = usePostSystemAlertConfiguration(
    handleRequest,
    closeModal,
    initialData.id
  );

  return (
    <Formik
      enableReinitialize
      initialValues={initialData.data}
      validationSchema={SYSTEM_ALERT_CONFIGURATION_VALIDATION}
      onSubmit={(values) => {
        mutate(values);
      }}>
      {({ touched, handleChange, errors, values }) => {
        return (
          <ModalComponent
            show={isModalOpen}
            closeModal={closeModal}
            loading={loading}
            size='md'
            title={`${initialData.modalStatus} Alert Recipient`}
            valueEdited={_.isEqual(values, initialData.data)}
            id={id}
            children={
              <Form id='systemAlertConfigurationForm'>
                <ModalBody id='systemAlertConfigurationModalBody'>
                  <InputText
                    type='text'
                    label='Name'
                    name='name'
                    id='name'
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                    inputType={initialData.modalStatus}
                    disabled={initialData.modalStatus === 'View'}
                    required
                  />
                  <InputText
                    type='email'
                    label='Email'
                    name='email'
                    id='email'
                    onChange={handleChange}
                    errors={errors}
                    touched={touched}
                    inputType={initialData.modalStatus}
                    disabled={initialData.modalStatus === 'View'}
                    required
                  />
                  <CustomToggle
                    label='Active'
                    name='isActive'
                    id='isActive'
                    checked={values.isActive}
                    onChange={handleChange}
                    disabled={initialData.modalStatus === 'View'}
                  />
                </ModalBody>
                <ModalFooterComponent
                  id='systemAlertConfigurationModalFooter'
                  modalStatus={initialData.modalStatus}
                  onCloseModal={() => {
                    closeModal();
                  }}
                  onEditModal={() => {
                    setModalStatus('Edit');
                  }}
                  valueChanged={_.isEqual(values, initialData.data)}
                  loading={isLoading}
                />
              </Form>
            }
          />
        );
      }}
    </Formik>
  );
};

export default SystemAlertConfigurationModal;
